import { _request_KEYCLOAK } from "../../request/_request_KEYCLOAK";

export const getFinanceData = async ({
  cnpj,
  year,
  month,
  page = 1,
  pageSize = 5,
  invoicePage = 1,
  invoicePageSize = 5,
  estados,
  cnpjs,
  statusPagamento,
}) => {
  const response = await _request_KEYCLOAK({
    method: "GET",
    url: `${process.env.REACT_APP_TICKET_INT012}/${cnpj}/finance`,
    params: {
      year,
      month,
      page,
      pageSize,
      invoicePage,
      invoicePageSize,
      ...(estados?.length ? { estados: estados.join(",") } : {}),
      ...(cnpjs?.length ? { cnpjs: cnpjs.join(",") } : {}),
      ...(statusPagamento?.length ? { statusPagamento: statusPagamento.join(",") } : {}),
    },
  });

  return response.data;
};